/**
 * 생성 리포트 히스토리 R2 API 헬퍼
 * /api/report-history-proxy GET/PUT/DELETE. apiClient(Bearer 자동 + 401 refresh) 사용.
 * reportGroupApi.js 와 동일한 brand_slug 쿼리 규약.
 */
import { apiClient } from "./apiClient.js";

const BASE = "/api/report-history-proxy";
export const isReportStorageId = value => (typeof value === "string" || Number.isSafeInteger(value)) && /^[A-Za-z0-9_-]{1,120}$/.test(String(value));

/** 리포트 저장 (timestamp 자동 부여) → { ok, timestamp } */
export async function saveReport(brandSlug, reportPayload) {
  const timestamp = String(reportPayload.timestamp || Date.now());
  const body = {
    ...reportPayload,
    timestamp,
    saved_at: reportPayload.saved_at || new Date().toISOString(),
  };
  const resp = await apiClient(
    `${BASE}?brand_slug=${encodeURIComponent(brandSlug)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
  );
  if (!resp.ok) throw new Error(`저장 실패: ${resp.status}`);
  const receipt = await resp.json().catch(() => null);
  if (receipt?.ok !== true || receipt.timestamp !== timestamp)
    throw new Error("저장 결과를 확인하지 못했습니다. 같은 보고서로 다시 저장해 주세요.");
  return receipt;
}

/** 목록 조회 (본문 미로드) → { items: [{ timestamp, metadata, ... }] } (최신순) */
export async function listReports(brandSlug) {
  const resp = await apiClient(
    `${BASE}?brand_slug=${encodeURIComponent(brandSlug)}&list=true`,
  );
  if (!resp.ok) throw new Error("보관함을 불러오지 못했습니다. 다시 시도해 주세요.");
  const result = await resp.json().catch(() => null);
  if (!Array.isArray(result?.items)) throw new Error("보관함 응답을 확인하지 못했습니다. 다시 시도해 주세요.");
  return result;
}

/** 단건 조회 (저장 본문 전체) */
export async function loadReport(brandSlug, timestamp) {
  const resp = await apiClient(
    `${BASE}?brand_slug=${encodeURIComponent(brandSlug)}&ts=${encodeURIComponent(timestamp)}`,
  );
  if (!resp.ok) throw new Error(`불러오기 실패: ${resp.status}`);
  const saved = await resp.json();
  if (!isReportStorageId(timestamp) || !saved || typeof saved !== "object" || Array.isArray(saved) ||
      (saved.timestamp != null && String(saved.timestamp) !== String(timestamp)))
    throw new Error("저장된 보고서의 식별 정보를 확인하지 못했습니다.");
  return { ...saved, timestamp: String(timestamp) };
}

/** 단건 삭제 */
export async function deleteReport(brandSlug, timestamp) {
  const resp = await apiClient(
    `${BASE}?brand_slug=${encodeURIComponent(brandSlug)}&ts=${encodeURIComponent(timestamp)}`,
    { method: "DELETE" },
  );
  if (!resp.ok) throw new Error(`삭제 실패: ${resp.status}`);
  const receipt = await resp.json().catch(() => null);
  if (receipt?.ok !== true) throw new Error("삭제 결과를 확인하지 못했습니다. 보관함을 다시 불러와 확인해 주세요.");
  return receipt;
}
